<template>
  <div class="DockingSystemTitle" :class="underlineType?'underlineType':''">
      <div class="title" :class="titleCenter?'titleCenter':''">
          {{title}}
      </div>
      <!-- moreType是否显示[查看更多] underlineType是否显示下划线 -->
      <div class="more" v-show="moreType" >
          查看更多
          <img src="../../../../public/static/images/right-arrow.png" alt="">
          <img src="../../../../public/static/images/right-arrow.png" alt="">
      </div>
  </div>
</template>

<script>
export default {
    props:{
        title:String,
        moreType:Boolean,
        underlineType:Boolean,
        titleCenter:Boolean,
    },
    components:{},
    data(){
        return{

        }
    },
    created:function(){

    },
    methods:{},

}
</script>

<style scoped>
@media (max-width: 768px) {
    .DockingSystemTitle{
        margin: 0 15px !important;
        padding-top: 20px !important;
    }
    .DockingSystemTitle .title{
        /* font-size: 20px; */
        font-size: 24px;
    }
    .DockingSystemTitle .title::after{
        width: 95px;
        height: 7px;
    }
}
.DockingSystemTitle{
    display: flex;
    justify-content: space-between;
    margin:0 30px;
    padding-top: 40px;
    position: relative;
}
.underlineType::after{
    content: "";
    width: 100%;
	border: solid 1px #dcdcdc;
	opacity: 0.35;
    position: absolute;
    bottom: 4px;

}
.title{

	
	font-size: 32px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
    position: relative;
}
.title::after{
    
    content: "";
    display: block;
	width: 126px;
	height: 11px;
	background-color: #00ffff;
	border-radius: 4px;
    margin-top: 20px;
    position: relative;
    z-index: 1;
}
.more{
	
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
    margin-top: 21px;
    position: relative;
}
.more img{
    position: relative;
    top:2px;
}
.titleCenter{
    text-align: center;
}
</style>